// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import * as d3 from 'd3';
import meta from './data/meta.json';
import * as hashes from './data/hash-dict';

import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

let latestData;

const mapboxgl = require('mapbox-gl');

const pkg = require('../package.json');

const ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  // ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let chartData;
let rawData;
let lastUpdated;
let subheadText;

d3.json('https://ix.cnn.io/data/wildfire-incidents/toplines.json').then((data) => {
  rawData = data;
  lastUpdated = data.agency_update_str.replace('AM', 'a.m.').replace('PM', 'p.m.');
  subheadText = data.summary;

  const timeStampFootnoote = d3.select('p#timestamp')
    .html(`Data last updated: ${lastUpdated}.`);


  subheadText = '';
  const subhead = d3.select('h2.dek')
    .html(`${subheadText}`);


  // const timeStampFootnoote = d3.select('p#timestamp')
  //   .html('Data last updated January 9, 2025 at 7:05 a.m. ET.');
  // .html('Data last updated January 8, 2025 at 8:00 p.m. ET. Smoke data is from January 7, 2025 at 6:00 p.m. ET.');


  if (pymChild) pymChild.sendHeight();

  // draw();
  // window.onresize = draw;
});

function draw() {
  if (process.env.NODE_ENV === 'development') {

  }
}

mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

// const MAP_ID = 'mapbox://styles/cnndigital/clq432mvc019m01qm3htp3bre'
const MAP_ID = 'mapbox://styles/cnndigital/cl960ytee001215qu1uhorjlx';

const LAYER_OPACITY = 1;

const state_hashes = hashes.default;
let mapParams;
let hasLocation;
let usingParentDotHtml = false;
let outageEvent;

// check for URL params
function checkParams(events) {
  // use the staging parent URL if we're in the CNN staging environment
  // otherwise use the straight url
  let url;
  if ((pymChild.parentUrl) && (pymChild.parentUrl.indexOf('/parent.html') !== -1)) {
    url = pymChild.parentUrl;
    usingParentDotHtml = true;
  } else {
    url = window.location.href;
  }

  // console.log('Parent url:', pymChild.parentUrl);
  // console.log('Using url:', url);

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  const splitMbhash = (text) => {
    let hasharray = [];
    hasharray = text.split('/').map(Number);

    // return the bearing as 0 if it's missing
    if (hasharray.length == 3) {
      hasharray[3] = 0;
    }
    return hasharray;
  };


  mapParams = getParams(url);
  if ('lnglat' in mapParams) {
    mapParams.lnglat = [parseFloat(mapParams.lnglat.split(',')[0]), parseFloat(mapParams.lnglat.split(',')[1])];
  }
  if ('z' in mapParams) {
    mapParams.z = parseFloat(mapParams.z);
  }
  if ('bearing' in mapParams) {
    mapParams.bearing = parseFloat(mapParams.bearing);
  }
  if ('state' in mapParams) {
    mapParams.mbhash = state_hashes[mapParams.state.toUpperCase()];
    console.log('centered on ', mapParams.state.toUpperCase());
  }
  if ('event' in mapParams) {
    const find_event = events.filter(d => d.event_code == mapParams.event);

    if (find_event) {
      outageEvent = find_event[0];
    }

    if (outageEvent && outageEvent.map_view) {
      mapParams.mbhash = outageEvent.map_view;
      console.log('using event', mapParams.event);
    }
  }
  if ('mbhash' in mapParams) {
    const parsedHash = splitMbhash(mapParams.mbhash);
    mapParams.z = parsedHash[0];
    mapParams.lnglat = [parsedHash[2], parsedHash[1]];
    mapParams.bearing = parsedHash[3];
  }

  if (!('scale' in mapParams)) {
    mapParams.scale = 'high';
  }


  // Set params to true if they have what we want (zoom + lng/lat)
  hasLocation = !!('lnglat' in mapParams && 'z' in mapParams);

  // console.log('mapParams', mapParams);
  // console.log('hasLocation', hasLocation);
}


checkParams();


// const mapBounds = [
//   [-112.000000, 23.7], // Southwest corner: [longitude, latitude]
//   [-80.3, 40.6], // Northeast corner: [longitude, latitude]
// ];

const mapBounds = [
  [-125.000000, 24.396308], // Southwest corner: [longitude, latitude]
  [-66.934570, 49.3457868], // Northeast corner: [longitude, latitude]
];


// screen size config
const optionsSm = {
  initZoom: 7.30,
  minZoom: 7,
  maxZoom: 11,
  center_v1: [-118.39, 34.05],
  center_v2: [-118.34605267235085, 34.200070747917984],
  center: [-118.63210, 34.14190],
  mapBounds,
};


const optionsLg = {
  initZoom: 8.2,
  minZoom: 8,
  maxZoom: 11,
  center_v1: [-118.39, 34.05],
  center_v2: [-118.3817605158682, 34.22846170121762],
  center: [-118.62580, 34.17118],
  mapBounds,
};


const container = d3.select('#graphic');
container.html('');

const mq = window.matchMedia('(min-width: 420px)');

// container.append('div')
//   .attr('id', 'map');
let options;

const updateOptions = (opts, isSmall) => {
  if (mapParams && mapParams.lnglat) {
    opts.center = mapParams.lnglat;
    opts.initZoom = (isSmall) ? mapParams.z - 0.75 : mapParams.z;
  }
  return opts;
};

const handleBrowserSize = () => {
  if (mq.matches) {
    d3.select('#map').attr('style', 'width: 100%; height: 500px;');
    options = optionsLg;
    options = updateOptions(optionsLg, false);
  } else {
    d3.select('#map').attr('style', 'width: 100%; height: 300px;');
    options = optionsSm;
    options = updateOptions(optionsSm, true);
  }
};
handleBrowserSize();


const map = new mapboxgl.Map({
  container: 'map',
  style: MAP_ID,
  center: options.center,
  zoom: options.initZoom,
  maxZoom: options.maxZoom,
  minZoom: options.minZoom,
  bearing: 0,
  scrollZoom: true,
  dragRotate: false,
  logoPosition: 'bottom-right',
  touchPitch: false,
  interactive: true,
  projection: 'albers',
  maxBounds: options.mapBounds,
});

// disable map rotation using right click + drag
map.dragRotate.disable();

// disable map rotation using touch rotation gesture
map.touchZoomRotate.disableRotation();


const nav = new mapboxgl.NavigationControl({
  showCompass: false,
});
map.addControl(nav, 'top-right');


map.on('load', () => {
  // Add a new GeoJSON source using a public URL
  // map.addSource('fire-source', {
  //   type: 'geojson',
  //   data: 'https://ix.cnn.io/data/wildfire-incidents/current_wildfire_all.geojson',
  // });

  // Add a layer to visualize the GeoJSON data
  map.addLayer({
    id: 'fire-perimeter-layer',
    type: 'fill',
    source: 'fire-source',
    paint: {
      'fill-color': '#BA0017',
      'fill-opacity': 0.4,
    },
  });

  const geojsonData = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.67453, 34.1822] },
        properties: { Name: 'Kenneth Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.57453, 34.09022] },
        properties: { Name: 'Palisades Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.09718, 34.2192] },
        properties: { Name: 'Eaton Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.577867, 34.566841] },
        properties: { Name: 'Hughes Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.478134, 34.33733] },
        properties: { Name: 'Hurst Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-119.20224, 34.23661] },
        properties: { Name: 'Auto Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.498234, 34.2901] },
        properties: { Name: 'Archer Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.2433, 34.4408] },
        properties: { Name: 'Lidia Fire', active: 'false' },
      },
      {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [-118.35, 34.09] },
        properties: { Name: 'Sunset Fire', active: 'false' },
      },
    ],
  };

  // Function to dynamically update text offsets based on screen size
  const updateFireOffsets = () => {
    const isDesktop = window.matchMedia('(min-width: 420px)').matches;

    // Update offsets for each fire
    geojsonData.features.forEach((feature) => {
      if (feature.properties.Name === 'Archer Fire') {
        feature.properties.offset = isDesktop ? [-1, -0.5] : [0, 0.3];
      } else if (feature.properties.Name === 'Sunset Fire') {
        feature.properties.offset = isDesktop ? [-1, -0.4] : [0, 0.3];
      } else {
        feature.properties.offset = isDesktop ? [0, -1.5] : [0, -1];
      }
    });

    // Update the source dynamically
    if (map.getSource('local-geojson')) {
      map.getSource('local-geojson').setData(geojsonData);
    }
  };

  // Initial call to set offsets
  updateFireOffsets();

  // Recalculate offsets on screen resize
  window.addEventListener('resize', updateFireOffsets);

  map.addSource('local-geojson', {
    type: 'geojson',
    data: geojsonData,
  });


  // 'text-offset': ['get', 'offset'], // Dynamic offsets


  // Add the text label layer
  map.addLayer({
    id: 'fire-label-layer',
    type: 'symbol',
    source: 'local-geojson',
    layout: {
      'text-field': ['get', 'Name'], // Use the "Name" property for labels
      'text-font': ['CNN Sans Display Bold', 'Arial Unicode MS Bold'],
      'text-size': 12,
      // 'text-offset': [
      //   'interpolate',
      //   ['linear'],
      //   ['zoom'],
      //   5, [0, -1], // Slight offset at zoom level 5
      //   10, [0, -2], // Larger offset at zoom level 10
      // ],
      'text-offset': ['get', 'offset'], // Dynamic offsets
      'text-anchor': 'center',
      'text-allow-overlap': true,
    },
    paint: {
      'text-halo-color': '#FFFFFF', // White halo
      'text-halo-width': 1,
      'text-halo-blur': 0.5,
      'text-color': [
        'match',
        ['get', 'active'],
        'true', '#000000',
        'false', '#666666',
        '#CCCCCC', // Default value: If no match
      ],
    },
  });

  // Add landmarks (unchanged)
  map.addSource('landmark-geojson', {
    type: 'geojson',
    data: 'https://ix.cnn.io/data/wildfire-incidents/landmarks.geojson',
  });

  map.addLayer({
    id: 'circle-layer',
    type: 'circle',
    source: 'landmark-geojson',
    paint: {
      'circle-radius': 2,
      'circle-stroke-color': '#000000',
      'circle-stroke-width': 0,
      'circle-color': '#262626',
    },
  });

  map.addLayer({
    id: 'landmark-label-layer',
    type: 'symbol',
    source: 'landmark-geojson',
    layout: {
      'text-field': ['get', 'name'],
      'text-font': ['CNN Sans Display Regular', 'Arial Unicode MS Bold'],
      'text-size': 12,
      'text-offset': [0.5, 0.5],
      'text-anchor': 'left',
    },
    paint: {
      'text-color': '#262626',
      'text-halo-color': '#FFFFFF',
      'text-halo-width': 1,
    },
  });


  // Inactive fires
  geojsonData.features
    .filter(d => d.properties.active === 'false')
    .forEach((loc) => {
      const file_name = loc.properties.Name.toLowerCase().split(' ').join('_');
      const geojsonUrl = `https://ix.cnn.io/data/wildfire-incidents/individual_fires/${file_name}.geojson`; // Construct the GeoJSON URL

      // Fetch the GeoJSON
      fetch(geojsonUrl)
        .then(response => response.json())
        .then((data) => {
          const name = loc.properties.Name;
          // Add a new source for this GeoJSON
          const sourceId = `${name}-source`;
          const layerId = `${name}-layer`;
          const labelLayerId = `${name}-labels`;

          map.addSource(sourceId, { type: 'geojson', data });

          // Add a layer for the features
          map.addLayer({
            id: layerId,
            type: 'fill',
            source: sourceId,
            paint: {
              'fill-color': '#3a3a3a',
              'fill-opacity': 0.4,
              'fill-outline-color': '#000000',
            },
          });
        })
        .catch((error) => {
          console.error(`Error loading GeoJSON for ${loc.name}:`, error);
        });
    });


  // map.on('move', () => {
  //   const center = map.getCenter();
  //   const zoom = map.getZoom();
  //   const bounds = map.getBounds(); // Get the map bounds

  //   console.log(`Zoom: ${zoom.toFixed(2)}, Center: [${center.lng.toFixed(5)}, ${center.lat.toFixed(5)}]`);
  //   console.log(`Bounds: SW [${bounds.getSouthWest().lng.toFixed(5)}, ${bounds.getSouthWest().lat.toFixed(5)}], NE [${bounds.getNorthEast().lng.toFixed(5)}, ${bounds.getNorthEast().lat.toFixed(5)}]`);
  // });
});

let prevW = window.innerWidth;
const redraw = () => {
  if (!map || window.innerWidth === prevW) return;
  handleBrowserSize();
  map.setMaxBounds(options.mapBounds);
  map.setMaxZoom(options.maxZoom);
  map.setMinZoom(options.minZoom);
  map.setZoom(options.initZoom);
  map.setCenter(options.center);
  map.resize();
  prevW = window.innerWidth;
};
window.addEventListener('resize', redraw);


// fyi, disabling an empty mapbox button in graphic.scss with
// .mapboxgl-ctrl-attrib-button { display: none }
